module.exports = __webpack_public_path__ + "img/medal_svip2.d3f5886.png";